import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {mbeConfigService} from './mbe-config.service';
import {Observable} from 'rxjs';
import { ServicePointInfo, ServicePointInfoAPI } from '../model/servicepointsetup';

@Injectable({
  providedIn: 'root'
})
export class ServicePointInfoService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllSPI(pageIndex: number, pageSize: number, sortActive: string, sort: string, servicePointName: string, spiRno: number): Observable<ServicePointInfoAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<ServicePointInfoAPI>(`${this.URL}/spi/allspi/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}/${servicePointName ? servicePointName : 0}/${spiRno ? spiRno : 0}`, {headers});
  }

  getSPI(id: number): Observable<ServicePointInfo> {
    console.log('id:', id);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<ServicePointInfo>(`${this.URL}/spi/getspi/${id}`, {headers});
  }
}
